import { FrameComponent } from "../../common/FrameComponent";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { selectPracticumOValue } from "./redux/selectors";
import styles from "./styles.module.css";

export const Practicum = () => {
  const value = useAppSelector(selectPracticumOValue);

  return (
    <div className={styles.container}>
      <FrameComponent src={value?.html_url || ""} />
    </div>
  );
};
